import capitalize from '@framework/data-helpers/string/capitalize';
import { ThemeType } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/themeTypes';
import LogInButton from '@/creditflowresearch/ui/common/components/LogInButton';
import { mapArticleTypeToTitle } from '@/creditflowresearch/ui/components/creditFlow/articles/constants';
import {
  getProDescription,
  getUnauthorizedDescription,
} from '@/creditflowresearch/ui/common/components/organisms/constants';
import TileAccessFallback from '@/creditflowresearch/ui/common/components/organisms/TileAccessFallback';
import { useGetLinkToAllArticles } from '@/creditflowresearch/ui/components/creditFlow/articles/common/useGetLinkToAllArticles';

import styles from './articlesTiles.module.scss';

const getTooltipContent = (type: ThemeType) => (
  `Real-time ${ type === ThemeType.commentary ? 'commentary' : 'deal updates' } on the credit market written by
    industry leading analysts with years of reporting experience.`
);

interface IArticleTileFallbackProps {
  articleType: ThemeType,
  isAuthorized?: boolean,
}

const ArticleTileFallback = ({
  articleType,
  isAuthorized = false,
}: IArticleTileFallbackProps) => {
  const baseProps = {
    title: mapArticleTypeToTitle[articleType],
    dataTest: `accessFallback${ capitalize(articleType) }`,
    tooltipContent: getTooltipContent(articleType),
  };
  const { link } = useGetLinkToAllArticles(articleType);

  if (isAuthorized) {
    return (
      <TileAccessFallback
        { ...baseProps }
        description={ (
          <div className={ styles.authFallbackTileDescription }>{ getProDescription(link) }</div>
        ) }
      />
    );
  }

  return (
    <TileAccessFallback
      { ...baseProps }
      description={ (
        <div className={ styles.unAuthFallbackTileDescription }>{ getUnauthorizedDescription(link) }</div>
      ) }
      actionButton={ <LogInButton withIcon={ false } variant="outline" /> }
    />
  );
};

export default ArticleTileFallback;
